import { Check } from "lucide-react";

const BULLETS = [
  "Personalised programming — no copy-paste plans",
  "Patient coaching for first-timers and experienced athletes",
  "Strong work ethic; shows up, trains with you, every session",
  "Progressive overload and measurable progress tracking",
  "Youth athlete development with confidence-first approach",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="section border-t border-white/10">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] overflow-hidden border border-white/10">
            <img
              src="https://images.pexels.com/photos/35986381/pexels-photo-35986381.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720"
              alt="Coach Manny with client"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/70">
                  Head Coach
                </div>
                <div className="font-display text-3xl uppercase">Manny</div>
              </div>
              <div className="text-right">
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/70">
                  Based in
                </div>
                <div className="font-display text-xl uppercase">Caldwell, ID</div>
              </div>
            </div>
          </div>
          <div className="hidden lg:block absolute -bottom-6 -right-6 w-40 h-40 border border-[#FF3B30]" />
        </div>

        <div className="lg:col-span-7">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#FF3B30] mb-4">
            / 02 — Meet Coach Manny
          </div>
          <h2
            data-testid="about-title"
            className="font-display text-5xl md:text-6xl uppercase leading-[0.95] tracking-tight"
          >
            Your coach.
            <br />
            Your accountability.
            <br />
            <span className="text-[#FF3B30]">Your results.</span>
          </h2>
          <p className="text-white/70 mt-6 text-base md:text-lg leading-relaxed max-w-xl">
            Coach Manny has built Meño Coaching on one idea: everyone deserves a
            coach who actually shows up. Whether you're getting back in shape,
            chasing a PR, or developing your kid's soccer skills — the sessions
            are built around you. Patient, direct, and relentless about your
            progress.
          </p>
          <ul className="mt-8 space-y-3">
            {BULLETS.map((b) => (
              <li
                key={b}
                className="flex items-start gap-3 text-white/85"
                data-testid="about-bullet"
              >
                <span className="mt-1 w-5 h-5 bg-[#FF3B30]/15 border border-[#FF3B30]/40 flex items-center justify-center shrink-0">
                  <Check size={12} className="text-[#FF3B30]" />
                </span>
                <span>{b}</span>
              </li>
            ))}
          </ul>
          <div className="mt-10 flex flex-wrap gap-4">
            <a href="#book" data-testid="about-cta" className="btn-primary">
              Start Training
            </a>
            <a href="#testimonials" data-testid="about-reviews" className="btn-secondary">
              Read Reviews
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
